(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["tr-TR"] = {
            name: "tr-TR",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                percent: {
                    pattern: ["-%n","%n"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Turkish Lira",
                    abbr: "TRY",
                    pattern: ["-$n","$n"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "₺"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],
                        namesAbbr: ["Paz","Pzt","Sal","Çar","Per","Cum","Cmt"],
                        namesShort: ["Pa","Pt","Sa","Ça","Pe","Cu","Ct"]
                    },
                    months: {
                        names: ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],
                        namesAbbr: ["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"]
                    },
                    AM: ["ÖÖ","öö","ÖÖ"],
                    PM: ["ÖS","ös","ÖS"],
                    patterns: {
                        d: "d.MM.yyyy",
                        D: "d MMMM yyyy dddd",
                        F: "d MMMM yyyy dddd HH:mm:ss",
                        g: "d.MM.yyyy HH:mm",
                        G: "d.MM.yyyy HH:mm:ss",
                        m: "d MMMM",
                        M: "d MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "HH:mm",
                        T: "HH:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy",
                        Y: "MMMM yyyy"
                    },
                    "/": ".",
                    ":": ":",
                    firstDay: 1
                }
            }
        };
    })();

}));
